import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import FormLabel from '../label';

const TextFieldResizable = (props) => {
  const { label, id, placeholder, onBlur, onChange, value, rows = 3, maxLength = 1000 } = props;
  return (
    <div className="text-field">
      <FormLabel
        label={label}
        forId={id}
      />
      <TextareaAutosize
        id={id}
        name={id}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        rows={rows}
        maxLength={maxLength}
      />
    </div>
  );
};

export default TextFieldResizable;
